<template>
<div style="border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
    <div class="row">
        <div class="col-7 text-left">
            <h4 class="card-title pb-2 pt-2 mb-0">Penanggung Jawab Magang</h4>
        </div>
        <div class="col-5">
        </div>
    </div>
    <div class="row no-gutters">
        <div class="col-md-1">
            <hr class="border-primary"/>
        </div>
        <div class="col-md-11">
            <hr/>
        </div>
    </div>
    <div class="row no-gutters" v-if="datas.length != 0">
        <div class="col-4 p-4 d-flex" v-for="(item, id) in datas" :key="id">
            <div class="card w-100 card-detail text-center p-3">
                <div class="row no-gutters">
                    <div class="col-10" style="text-align:left!important">
                        <span style="font-size:16px" class="font-weight-bold">{{item.tipe}}</span>
                    </div>
                    <div class="col-2">
                        <img :src="pencilIcon" @click="goEdit(id)" title="edit" style="cursor:pointer" width="24px" height="24px" class="ml-1"/>
                    </div>
                </div>
                <hr class="mt-2 mb-4"/>
                <div class="row mb-4 no-gutters">
                    <div class="col-12">
                        <img v-if="item.urlFoto != 'null' || item.urlFoto != '' || item.urlFoto != null" @error="changeDefault" width="100" height="100" style="border-radius:50%;background-color:#dcdcdc;object-fit: cover" :src="item.urlFoto" />
                        <img v-else :src="photo" width="100" height="100" style="border-radius:50%;background-color:#dcdcdc"/>
                    </div>
                </div>
                <div class="row no-gutters mt-3">
                    <div class="col-12">
                        <span style="font-size:14px" class="font-weight-bold text-center">{{item.nama}}</span>
                    </div>
                </div>
                <div class="row no-gutters mt-1">
                    <div class="col-12">
                        <span class="text-center">{{item.jabatan}}</span>
                    </div>
                </div>
                <div class="row no-gutters mt-1">
                    <div class="col-12">
                        <a v-if="item.urlTtd != 'null' && item.urlTtd != null && item.urlTtd != ''" class="text-center" target="_blank" :href="item.urlTtd" title="lihat ttd" style="cursor:pointer">ttd</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="row no-gutters">
        <div class="col-12 p-5 text-center">
            Maaf, Data Tidak Ditemukan.
        </div>
    </div>
    <CModal
        size="lg"
        :centered="true"
        color="white"
        :show.sync="changeModal"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Detail {{inputHeader}}</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="changeModal = false" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div class="mb-5" style="padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Penanggung Jawab {{inputHeader}}</label>
                        <div class="autocomplete">
                            <input type="text"
                                    class="form-control"
                                    @click="toggleVisiblePegawai()"
                                    @blur="toggleCloseVisiblePegawai()"
                                    :class="{ 'is-invalid':$v.queryPegawai.$error, 'is-valid': !$v.queryPegawai.$invalid }"
                                    v-model.trim="$v.queryPegawai.$model"
                                    v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                                    @keydown.up="upPegawai"
                                    @keydown.down="downPegawai"
                                    @keydown.enter="selectItemPegawai"
                                    placeholder="Pilih Pegawai"
                            >
                            <div class="popovers" v-show="visiblePegawai">
                                <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesPegawai"
                                        :key="index"
                                        :class="{ 'selected': (selectedPegawai == index)}"
                                        @click="itemClickedPegawai(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                    </CCol>
                    <CCol sm="6">
                        <label>Nomor Induk Pegawai</label>
                        <input v-model="inputNip" class="form-control" placeholder="NIP" disabled style="background-color:whitesmoke" />
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <label>Jabatan</label>
                        <input v-model="inputJabatan" class="form-control" placeholder="Jabatan" disabled style="background-color:whitesmoke" />
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <label>Signature (.jpg, .png) *Maks 2MB</label>
                        <div v-if="urlImage == '' || urlImage == 'null'">
                            <input v-on:change="onFileChange" style="position:absolute;opacity:0;z-index:1;cursor:pointer" type="file" class="mr-2" accept=".jpg, .png, .bmp" />
                            <div :class="classSignature">+</div>
                        </div>
                        <div v-else>
                            <img :src="urlImage" width="56" height="56" />
                            <button @click="removeImage()" class="ml-3 btn btn-danger" size="sm">Delete</button>
                        </div>
                    </CCol>
                </CRow>
            </div>
            <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                <CCol sm="6">
                    <CButton style="width: 100%!important" @click="changeModal = false" class="btn-cancel">Kembali</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton style="width: 100%!important" @click="submitForm()" class="btn-edit-submit">Simpan</CButton>
                </CCol>
            </CRow>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
</div>
</template>
<script>
import {DataApi, DataApiUpload} from "../service/DataApi";
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'

export default {
    mixins: [validationMixin],
    validations: {
        queryPegawai: {
            required
        },
    },
    data() {
        return {
            // data search select pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,
            idPegawaiAdd: '',

            pencilIcon: require('../assets/menu/icon_pencil.svg'),
            closeIcon: require('../assets/menu/icon_close.svg'),
            datas: [],
            photo: require('@/assets/image/images.svg'),
            changeModal: false,
            inputHeader: '',
            inputNip: '',
            inputJabatan: '',
            inputUnix: '',

            urlImage: '',
            showImage: '',
            urlPath: '',

            lvl: '',
            organisasi: '',
            classSignature: 'cards-image'
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
    },
    watch: {
        queryPegawai() {
            if(this.queryPegawai == '') {
                this.idPegawaiAdd = ''
                this.inputNip = ''
                this.inputJabatan = ''
            }
            this.getDataPegawai('null')
        },
        changeModal() {
            if(this.changeModal == false) {
                this.idPegawaiAdd = ''
                this.inputNip = ''
                this.inputJabatan = ''
                this.urlImage = ''
                this.urlPath = ''
                this.showImage = ''
                this.queryPegawai = ''
                this.inputHeader = ''
                this.inputUnix = ''
                this.classSignature = 'cards-image'
            }
        }
    },
    methods: {
        getDataPegawai(val) {
            let payload = ''
            if(val == 'null') {
                payload = {
                    bidang: '',
                    jabatan: '',
                    limit: 10,
                    nama: this.queryPegawai,
                    pageIn: 1,
                    pegawaiId: '',
                    tipePegawai: ''
                }
            } else {
                payload = {
                    bidang: '',
                    jabatan: '',
                    limit: 10,
                    nama: '',
                    pageIn: 1,
                    pegawaiId: val,
                    tipePegawai: ''
                }
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik,
                        nama: tempData[i].nama,
                        nip: tempData[i].nik,
                        jabatan: tempData[i].jabatan
                    }
                    this.dataPegawai.push(onPush)
                }
                if(val != 'null') {
                    this.queryPegawai = this.dataPegawai[0].nama
                    this.idPegawaiAdd = this.dataPegawai[0].value
                    this.inputNip = this.dataPegawai[0].nip
                    this.inputJabatan = this.dataPegawai[0].jabatan
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.nama
            this.idPegawaiAdd = this.selectedItemPegawai.value
            this.inputJabatan = this.selectedItemPegawai.jabatan
            this.inputNip = this.selectedItemPegawai.nip
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },

        getData() {
            DataApi.get("magang/penanggungjawab/lihat")
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data
                }
                else {
                    this.datas = []
                }
                this.$emit('flagPenanggungJawab', true)
            })
        },
        goEdit(id) {
            let temp = this.datas[id]
            this.getDataPegawai(temp.idPegawai)
            this.inputUnix = temp.unix
            this.inputHeader = temp.tipe
            this.inputJabatan = temp.jabatan
            this.inputNip = temp.nik
            this.urlImage = temp.urlTtd
            this.classSignature = 'cards-image'
            this.changeModal = true
        },
        changeDefault(e) {
            e.target.src = this.photo
        },
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.showImage = files[0];
            this.createImage(files[0]);
        },
        createImage(file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.urlImage = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        saveImage() {
            if (this.urlImage.split(":")[0] == 'data' && this.urlImage != '') {
                let imageData = this.showImage
                let idPegawaiData = 0
                let inOutData = "1"
                let kodePerusahaanData = this.organisasi
                let tanggalData = new Date()
                let lvlData = this.lvl

                const fd = new FormData()
                fd.append('file', imageData)
                fd.append('idPegawai', idPegawaiData)
                fd.append('inOut', inOutData)
                fd.append('kodePerusahaan', kodePerusahaanData)
                fd.append('tanggal', tanggalData)
                fd.append('lvl', lvlData)

                DataApiUpload.post('upload/file', fd)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.urlPath = response.data.urlPath
                        this.goSave()
                    } else {
                        alert('Upload Photo Failed !')
                        this.loading = false
                    }
                });
            } else if(this.urlImage == '') {
                this.urlPath = ''
                this.goSave()
            } else {
                this.urlPath = this.urlImage
                this.goSave()
            }
        },
        removeImage() {
            this.showImage = ''
            this.urlImage = ''
            this.urlPath = ''
        },
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
                if(this.urlImage == '') {
                    this.classSignature = 'err-sig'
                }
            } else {
                if(this.urlImage == '') {
                    this.classSignature = 'err-sig'
                } else {
                    this.classSignature = 'cards-image'
                    this.saveImage()
                    this.loading = true
                }
            }
        },
        goSave() {
            this.$emit('flagPenanggungJawab', false)
            let payload = {
                idPegawai: this.idPegawaiAdd,
                tipe: this.inputHeader,
                unix: this.inputUnix,
                urlTtd: this.urlPath
            }
            DataApi.post("magang/penanggungjawab/simpan", payload)
            .then( response => {
                let res = response.data
                if(res.success == true) {
                    this.changeModal = false
                    this.getData()
                }
            })
        },

        getDataToken() {
            DataApi.get("pegawai/role/cek")
            .then( response => {
                let res = response.data
                if(res.success == true) {
                    this.lvl = res.data.lvl
                    this.organisasi = res.data.organisasi
                    this.getData()
                }
            })
        }
    },
    mounted() {
        this.getDataToken()
        this.$emit('flagPenanggungJawab', false)
    },
}
</script>
<style scoped>
.card-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
    height: 100%;
}
.card-detail {
    font-size: 12px;
    text-align: center;
    background-color: whitesmoke;
    border-radius: 5px;
    -webkit-box-shadow: 0px 0px 10px -5px rgba(0,0,0,1);
    -moz-box-shadow: 0px 0px 10px -5px rgba(0,0,0,1);
    box-shadow: 0px 0px 10px -5px rgba(0,0,0,1);
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.btn-cancel {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-edit-submit {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.err-sig {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted red;
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
</style>
